export const header_tags_extension = {
  light: {
    nadelgreen: {
      color: "#AFE4B9",
    },
    nadelsky: {
      color: "#DCEEFE",
    },
    nadelgray: {
      color: "#DFE4E8",
    },
    nadelturquoise: {
      color: "#DEF3F1",
    },
    nadelskydark: {
      color: "#DCEEFE",
    },
    nadellightbrown: {
      color: "#DFE0DC",
    },
    nadelskydarkborder: {
      color: "#d7e0ee",
    },
  },
  dark: {
    nadelgreen: {
      color: "#123018",
    },
    nadelsky: {
      color: "#163E61",
    },
    nadelgray: {
      color: "#3C4B57",
    },
    nadelturquoise: {
      color: "#144440",
    },
    nadelskydark: {
      color: "#2F4A62",
    },
    nadellightbrown: {
      color: "#3B4C0B",
    },
    nadelskydarkborder: {
      color: "#d7e0ee",
    },
  },
};
